function lazyLoad(view) {
  return () => import(`./${view}.vue`)
}
export default {
  path: '/assignmentForm',
  component: lazyLoad('AssignmentFormRoot'),
  children: [
    {
      path: 'lti',
      name: 'LtiAssignmentFormView',
      component: lazyLoad('LtiAssignmentFormView'),
    },
    {
      path: 'classroom',
      name: 'ClassroomAssignmentFormView',
      component: lazyLoad('ClassroomAssignmentFormView'),
    },
  ],
}
